import options from './block-loader.directive';

export default {
    selector: 'dtBlockLoader',
    options
};
